import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiStockDepotCard, ApiStockDepotCardFilter } from "./types";

interface StockDepotCardsListResponse {
    depotcards: ApiStockDepotCard[];
}

/**
 * Транспортный слой OMP — карточки учёта СУ.
 */
export const stockDepotCardsApi = {
    /**
     * Загружает карточки депо по фильтру.
     * Запрос уходит в endpoint `stock/stockDepotcards.loadByFilter`.
     */
    load: async (params: { flt: ApiStockDepotCardFilter }, config?: RequestConfig): Promise<ApiStockDepotCard[]> => {
        const data = await ompApiClient.postOmega<StockDepotCardsListResponse>(
            "stock/stockDepotcards.loadByFilter",
            params,
            config,
        );
        return data.depotcards;
    },
} as const;
